import React from 'react';
import PropTypes from 'prop-types';
import { Column, Table } from '@tencent/spaui';
import PhoneInfo from '@/business-components/sale/PhoneInfo';
import WeChatAssociateModal from '@/business-components/sale/WeChatAssociateModal';
import ContactStatus from '@/components/ContactStatus';
import LinkButton from '@/components/LinkButton';
import WithPermission from '@/common/permissions/WithPermission';
import perms from '@/common/permissions/sale/perms';
import UserInfo from '@/business-components/sale/UserInfo';
import { withAccount } from '@/business-components/operator/account-context';
import message from '@/utils/message';
import { connect } from 'react-redux';
import permsConfig from '@/common/permissions/sale/perms-config';

class ContactListView extends React.Component {
  static propTypes = {
    leadId: PropTypes.number.isRequired,
    contactList: PropTypes.arrayOf(PropTypes.shape({
      contactId: PropTypes.number.isRequired,
      contactName: PropTypes.string.isRequired,
    })),
    readOnly: PropTypes.bool,
    secure: PropTypes.bool,
  }

  timer = null;

  render() {
    const { contactList, readOnly } = this.props;
    return (
      <Table data={contactList} className="contact-list">
        <Column name="contactName">联系人</Column>
        <Column name="title">职位</Column>
        <Column name="status" render={this.renderStatus}>
          状态
        </Column>
        <Column name="mobile" render={this.renderPhone}>
          手机
        </Column>
        <Column name="weChat">微信</Column>
        <Column name="relationId" render={this.renderWechatBind}>企微绑定</Column>
        <Column name="userId" render={this.renderColumn}>添加人</Column>
        {/* <Column name="tagNames" render={this.renderColumn}>企微标签</Column> */}
        <Column name="telephone" render={this.renderPhone}>
          固话
        </Column>
        <Column name="email">Email</Column>
        {readOnly || (
          <Column name="actions" render={this.renderActions}>
            操作
          </Column>
        )}
      </Table>
    );
  }

  /**
   * @description: 复制当前企微名称，2s后唤起企微
   */
  copyName = (name = ' ') => {
    const input = document.createElement('input');
    input.value = name;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.style.display = 'none';
    message.success('已复制当前企微名称到剪贴板');
    input.remove();
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      window.location.href = 'wxwork:';
    }, 2000);
  }

  renderStatus = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    return <ContactStatus status={value} />;
  }

  renderPhone = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    const { leadId, secure } = this.props;
    return <PhoneInfo
      leadDetail={this.props.lead}
      leadId={leadId}
      contactId={data.contactId}
      number={value}
      secure={secure}
      reloadPage={this.props.getContactList}
    />;
  }

  renderWechatBind = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    const { relationId, onlineSalesCustomer = {}, employeeId } = data.relation || {};
    const { account = {}, editPerm, loginStatus = {} } = this.props;
    const relation = {
      relationId,
      contactId: data.contactId,
      leadId: this.props.leadId,
    };
    if (!loginStatus?.isBindWorkWX || !permsConfig.onlineSales(account)) return null;
    return <span>
      {
        relationId ? <React.Fragment>
          {onlineSalesCustomer?.name}
          {
            account.user_id === employeeId
              ? <a onClick={() => this.copyName(onlineSalesCustomer?.name)} rel="nofollow" href="javascript:;" className="wechat-icon wechat-online"></a>
              : <a title="当前您企微未添加该客户，点击将吊起企微应用" rel="nofollow" href="wxwork:" className="wechat-icon wechat-offline"></a>
          }
        </React.Fragment> : null
      }
      {
        editPerm ? <WeChatAssociateModal callback={this.props.getContactList} titleText={relationId ? '修改' : '关联'} relation={relation} /> : null
      }
    </span>;
  }

  renderColumn = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    switch(name) {
      case 'userId':
        const { userId } = data.relation || {};
        const { loginStatus = {}, account } = this.props;
        if (!loginStatus?.isBindWorkWX || !permsConfig.onlineSales(account)) return null;
        return userId;
      case 'tagNames':
        const { tagNames = [] } = data.relation || {};
        return tagNames && tagNames.join(',');
      default:
        return value;
    }
  }

  renderActions = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }

    const { leadId, secure } = this.props;
    return (
      <div>
        <WithPermission oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL]}>
          <LinkButton>编辑</LinkButton>
          <LinkButton>删除</LinkButton>
        </WithPermission>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.loginStatus,
  };
}

export default withAccount(connect(mapStateToProps)(ContactListView));
